import _hasIn from 'lodash/hasIn';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';

class StripeAPIProvider extends Component {
  render() {
    // Skip Stripe initialization during pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      return <div>{this.props.children}</div>;
    }

    if (!this.props.stripeApiKey) {
      return <div />;
    }

    return <StripeProvider apiKey={this.props.stripeApiKey}>{this.props.children}</StripeProvider>;
  }
}

StripeAPIProvider.propTypes = {
  stripeApiKey: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

StripeAPIProvider.defaultProps = {
  stripeApiKey: null,
  children: null,
};

export function mapStateToProps(state) {
  let stripeApiKey = null;
  if (_hasIn(state, ['appdata', 'apiKeys', 'stripe'])) {
    stripeApiKey = state.appdata.apiKeys.stripe;
  }
  return { stripeApiKey };
}

export default connect(mapStateToProps)(StripeAPIProvider);



// WEBPACK FOOTER //
// ./src/components/StripeAPIProvider/index.js